import moment from 'moment-timezone';

export const maskEmailAddress = (email: string) => {
  const [localPart, domain] = email.split('@');
  return `${localPart?.substring(0, 4)}${'*'.repeat(15)}@${domain}`;
};

export function formatDateString(
  dateString: string,
  includeTime: boolean = false,
  customFormat?: string
): string {
  const date = moment(dateString);

  // Default format for the date
  let format = 'dddd, D MMMM YYYY'; // Monday, 4 September 2023

  // Add time format if includeTime is true
  if (includeTime) {
    format += ' HH:mm'; //04 September 2023 14:30
  }

  // Override with custom format if provided
  if (customFormat) {
    format = customFormat;
  }

  // Format the date (and time if included)
  return date.format(format);
}

export function generateDatesAroundToday(range: number = 2): Date[] {
  const today = new Date();
  const dates = [];

  for (let i = -range; i <= range; i++) {
    const date = new Date(today);
    date.setDate(today.getDate() + i);
    dates.push(date);
  }

  return dates;
}

export function formatDates(
  dates: Date[]
): { dateNumber: number; dayName: string }[] {
  return dates.map((date) => {
    const options: Intl.DateTimeFormatOptions = { weekday: 'short' };
    const dayName = date.toLocaleDateString(undefined, options);
    const dateNumber = date.getDate();

    return { dateNumber, dayName };
  });
}

export const getGreetingMessage = (): string => {
  const currentHour = new Date().getHours();
  if (currentHour < 12) {
    return 'Good morning';
  } else if (currentHour < 18) {
    return 'Good afternoon';
  } else {
    return 'Good evening';
  }
};

export const humanizeName = (name: string): string => {
  return name
    .replace(/[_\W]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase())
    .replace(/\s+/g, ' ');
};

export function setMomentTimezone(timezone: string) {
  moment.tz.setDefault(timezone);
}

export const formatDateInDDMMYY = (date: Date) => {
  if (!date) return '';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};
